export class TablePage {
  page: number;
  itemsPerPage: number;
  sortBy: Array<{ key: string; order: string }>;
  groupBy: string[];
  groupDesc: boolean[];
  mustSort = false;
  multiSort = false;

  constructor(itemsPerPage?: number) {
    this.itemsPerPage = itemsPerPage || 10;
    this.page = 1;
  }
}
